import { render, staticRenderFns } from "./SetupPlan.vue?vue&type=template&id=e21bf764&scoped=true"
import script from "./SetupPlan.vue?vue&type=script&lang=js"
export * from "./SetupPlan.vue?vue&type=script&lang=js"
import style0 from "./SetupPlan.vue?vue&type=style&index=0&id=e21bf764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21bf764",
  null
  
)

export default component.exports